import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=a777b64e"
import script from "./MainWrapper.vue?vue&type=script&lang=ts"
export * from "./MainWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports